module.exports = "/_next/static/images/cl-65517b63175b1d550c077cfc2d4003a2.svg";